import React from 'react'

const AvailableSlots = () => {
  return (
    <>
       <h4>AvailableSlots</h4>
    </>
  )
}

export default AvailableSlots
